import React, {Component} from "react";

/**
 *
 * Displays div with vertical colorful rectangles of identical width
 *
 * @param {string[]} [colors] - array of colors in rendering order
 * @param {object} [elementProps] - other props to pass into input element
 */

export default class CompareColorsSquare extends Component {
    render() {
        return (
            <div className="col-12 flex margin-bottom-10 border-black" {...this.props.elementProps}>
                {this.props.colors.map((color, index) => (
                    <div
                        key={index}
                        style={{backgroundColor: color, width: 100 / this.props.colors.length + "%"}}
                    ></div>
                ))}
            </div>
        );
    }
}
